import React from 'react';
import ReactDOM from 'react-dom';
import './styles/base.css';
import Default from './layouts/Default';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux'
import { store }  from './reducers'

ReactDOM.render(<Provider store={ store }><Default /></Provider>, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js